import { computed } from 'vue';
import { IRouter, Routes } from '@/models/router/router.interface';
import { ValidationResult } from '@studyportals/campaign-management-api-interface';
import { NotificationStatuses } from '@/models/notifications.interface';
import validationPresenter from '@/presenters/validation-presenter';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

export default class SaveBlockCode {

	public pageName = computed((): string => {
		switch (this.router.value.current) {
			case Routes.GENERAL:
				return 'Campaign Settings';
			case Routes.LINKED_ORGANISATIONS:
				return 'Linked Organisations';
			case Routes.ENTITIES_AND_GEOTARGETING:
				return 'Entities & Geotargeting';
			case Routes.CUSTOM_PRODUCTS:
				return 'Custom products';
			case Routes.RIGHTS:
				return 'Rights';
			case Routes.INTERNAL_NOTES:
				return 'Internal Notes';
			case Routes.AUDITOR:
				return 'Auditor';
			default:
				return '';
		}
	});

	public isSaveEnabled = computed((): boolean => {
		return store.getters.isSaveEnabled();
	});

	public isCampaignCreation = computed((): boolean => {
		return store.getters.isCampaignCreation();
	});

	public doesPageSupportSaving = computed((): boolean => {
		const currentRoute = this.router.value.current;
		return currentRoute !== Routes.AUDITOR;
	});

	public isSaveOrCreationInProgress = computed((): boolean => {
		const notificationStatus = store.getters.notificationStatus();
		return notificationStatus === NotificationStatuses.SAVING_IN_PROGRESS
			|| notificationStatus === NotificationStatuses.CREATION_IN_PROGRESS;
	});

	private router = computed((): IRouter => {
		return store.getters.router();
	});

	private validationResult = computed((): ValidationResult => {
		return store.getters.validationResult();
	});

	public saveCampaign(): void {
		validationPresenter.validateMandatoryFields();

		if (this.validationResult.value.invalid.length > 0 || this.validationResult.value.missing.length > 0) {
			return;
		}

		void campaignPresenter.saveCampaignDetails();
	}

	public createCampaign(): void {
		validationPresenter.validateMandatoryFields();

		if (this.validationResult.value.invalid.length > 0 || this.validationResult.value.missing.length > 0) {
			return;
		}

		void campaignPresenter.createCampaign();
	}
}
